import api from '../../../api/client'

function withSafePageSize(params = {}, fallback = 50) {
  const raw = Number(params?.pageSize)
  const safePageSize = Number.isFinite(raw)
    ? Math.min(100, Math.max(1, raw))
    : fallback
  return { ...params, pageSize: safePageSize }
}

export async function fetchConversations(params = {}) {
  const response = await api.get('/chat/conversations', { params: withSafePageSize(params) })
  return response.data
}

export async function fetchUsersForThread(params = {}) {
  const response = await api.get('/chat/users', { params: withSafePageSize(params) })
  return response.data
}

export async function startDirectThread(targetUserId) {
  const response = await api.post('/chat/threads/start', { targetUserId })
  return response.data
}

export async function fetchChannelMessages(channelId, params = {}) {
  const response = await api.get(`/chat/messages/${channelId}`, { params })
  return response.data
}

export async function fetchChannelDetails(channelId) {
  const response = await api.get(`/chat/channel/${channelId}`)
  return response.data
}

export async function fetchChannelAssets(channelId, params = {}) {
  const response = await api.get(`/chat/assets/${channelId}`, { params: withSafePageSize(params, 12) })
  return response.data
}

export async function sendChannelMessage(channelId, content, parentId = null) {
  const payload = {
    channelId,
    content,
  }
  if (parentId) payload.parentId = parentId
  const response = await api.post('/chat/messages', payload)
  return response.data
}

export async function markChannelRead(channelId, lastReadMessageId) {
  const response = await api.post('/chat/mark-read', {
    channelId,
    lastReadMessageId,
  })
  return response.data
}

export async function fetchChatUnreadSummary() {
  const response = await api.get('/chat/unread-summary')
  return response.data
}

export async function fetchChatHubKpis(params = {}) {
  const response = await api.get('/chat/hub-kpis', { params })
  return response.data
}

export async function fetchChatPresence(userIds = []) {
  const normalized = Array.from(
    new Set(
      (Array.isArray(userIds) ? userIds : [])
        .map((value) => Number(value))
        .filter((value) => Number.isFinite(value) && value > 0),
    ),
  )
  if (!normalized.length) return { items: [] }

  const query = new URLSearchParams()
  normalized.forEach((id) => query.append('userIds', String(id)))
  const response = await api.get(`/chat/presence?${query.toString()}`)
  return response.data
}

export async function uploadChannelAttachment(channelId, file) {
  const formData = new FormData()
  formData.append('file', file)
  const response = await api.post(`/chat/upload/${channelId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response.data
}

export async function createGroupChannel(name) {
  const response = await api.post('/chat/channel/create', { name })
  return response.data
}

export async function renameChannel(channelId, name) {
  const response = await api.post(`/chat/channel/${channelId}/rename`, { name })
  return response.data
}

export async function addChannelMember(channelId, userId) {
  const response = await api.post(`/chat/channel/${channelId}/members`, { userId })
  return response.data
}

export async function removeChannelMember(channelId, userId) {
  const response = await api.delete(`/chat/channel/${channelId}/members/${userId}`)
  return response.data
}
